<div class="lokos-reference">
    <div mat-dialog-title>
        <h4>{{ title | translate }}</h4>
        <h3 (click)="onCancel()">X</h3>
    </div>
    <mat-dialog-content>
        <div class="dialog-content">
            <img src="assets/images/warning_snackbar_icon.svg" alt="" />
            <h1>{{ message | translate }}</h1>
            <h1>
                {{ referenceNumber | translate }}
                <button mat-icon-button (click)="copyToClipboard()">
                    <mat-icon>content_copy</mat-icon>
                </button>
            </h1>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
        @if (cancelButtonLabel) {
            <lokos-button
                [label]="cancelButtonLabel | translate"
                [type]="'default'"
                [disabled]="false"
                (afterClick)="onCancel()"
            />
        }
        @if (confirmationButtonLabel) {
            <lokos-button
                [label]="confirmationButtonLabel | translate"
                [type]="'primary'"
                [disabled]="false"
                (afterClick)="onConfirm()"
            />
        }
    </mat-dialog-actions>
</div>
